import React, { useEffect, useState } from 'react';
import { Form, Table, Typography, InputNumber, Button, Space, message } from 'antd';
import PropTypes from 'prop-types';
import { useServicesUpdate } from '../../hooks/services/useServicesUpdate';

const { Text } = Typography;

const EditServiceCharges = ({ clinicLocationId, servicesList, onSuccess, onCancel }) => {
  const [form] = Form.useForm();
  const [tableData, setTableData] = useState(servicesList || []);
  const { loading, updateServiceCharges } = useServicesUpdate();

  const columns = [
    {
      title: 'Service Name',
      dataIndex: 'title',
      render: (value) => <Text style={{ textWrap: 'wrap' }}>{value}</Text>,
    },
    {
      title: 'Price',
      dataIndex: 'amount',
      align: 'right',
      render: (value, record, index) => (
        <InputNumber
          min={0}
          precision={2}
          value={value}
          onChange={(newValue) => {
            const newData = [...tableData];
            newData[index] = { ...record, amount: newValue || 0 };
            setTableData(newData);
          }}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: 'Rush Fee',
      dataIndex: 'rushFee',
      align: 'right',
      render: (value, record, index) => (
        <InputNumber
          min={0}
          precision={2}
          value={value}
          onChange={(newValue) => {
            const newData = [...tableData];
            newData[index] = { ...record, rushFee: newValue || 0 };
            setTableData(newData);
          }}
          style={{ width: '100%' }}
        />
      ),
    },
  ];

  useEffect(() => {
    form?.setFieldsValue({ services: tableData });
  }, [tableData, form]);

  const handleSubmit = async (values) => {
    const services = values?.services;
    console.log("services : ", services);
    if (services?.length > 0) {
      const result = await updateServiceCharges({
        clinicLocationId,
        services: services?.map(service => ({
          serviceId: service?.serviceId,
          amount: service?.amount,
          rushFee: service?.rushFee
        }))
      });
      console.log("result : ", result);
      message.success(result?.message);
      onSuccess();
    }
  }

  return (
    <Form form={form} layout="vertical" onFinish={handleSubmit}>
      <Form.Item name="services">
        <Table
          columns={columns}
          dataSource={tableData}
          pagination={false}
          rowKey={(record) => record?.serviceId}
          size="small"
        />
      </Form.Item>
      {/* Add submit and cancel buttons */}
      <Form.Item>
        <Space>
          <Button loading={loading} type='primary' htmlType='submit'>Submit</Button>
          <Button onClick={onCancel}>Cancel</Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

EditServiceCharges.propTypes = {
  form: PropTypes.any,
  servicesList: PropTypes.array,
  clinicLocationId: PropTypes.number,
  onSuccess: PropTypes.func,
  onCancel: PropTypes.func
};

export default EditServiceCharges;